




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ITranslationFormItem } from "@/models/translations";
import { ILanguage } from "@/models/constants";
import _ from "@/boot/lodash";

@Component
export default class TranslationsList extends Vue {
  @Prop({ required: true })
  public value!: ITranslationFormItem[];

  @Prop({ required: true })
  public languages!: ILanguage[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public fieldLabel!: string;

  @Prop({ required: true })
  public fieldName!: string;

  @Prop({ default: "text" })
  public fieldType!: string;

  @Prop({ default: () => ({}) })
  public rules!: Record<string, any>;

  // Data

  public translations: Record<ILanguage["id"], string> = {};

  // Computed

  public get mappedTranslations() {
    return _.map(this.translations, (val, language_id) => ({
      language_id,
      [this.fieldName]: val.trim()
    }));
  }

  // Life-cycle methods

  public created() {
    for (const lang of this.languages) {
      const translation = _.find(this.value, ["language_id", lang.id]);
      this.$set(
        this.translations,
        lang.id,
        translation?.[this.fieldName] ?? ""
      );
    }
  }

  // Watchers

  @Watch("mappedTranslations", { deep: true })
  public onTranslationsChange(val) {
    this.$emit("input", val);
  }
}
